import { render, staticRenderFns } from "./StaticData.vue?vue&type=template&id=c65880e8&scoped=true&"
import script from "./StaticData.vue?vue&type=script&lang=js&"
export * from "./StaticData.vue?vue&type=script&lang=js&"
import style0 from "./StaticData.vue?vue&type=style&index=0&id=c65880e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65880e8",
  null
  
)

export default component.exports